import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import SavedSearches from './components/SavedSearches';

const savedSearches = (props,{ t }) => (
  <Container>
    <SavedSearches {...props} />
  </Container>
);

savedSearches.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(savedSearches);
